import { CoinIcon } from "./coin-icon";
import ShieldPowerUpIcon from "./shields-power-up-icon";
import CollectibleXPToast from "./toast/toasts";

// MOCK DATAS
// let payload = {
//   netResult : "250",
//   isBroken : false,
//   isWinning: false,
//   isPowerUpUsed: true,
//   protectedAmount: 10,
//   powerUpCode: "shield_x_1",
//   savedAmount: 0,
//   collectibleCode: 'BTC',
//   collectibleXPAmount: 50,
//   isXPAdded: false,
// };

interface RushGameResultNotifProps {
  payload: any
}

const RushGameResultNotif: React.FC<RushGameResultNotifProps> = (props) => {

  const {payload} = props;

  const isWinning = payload.isWinning;
  const isBroken = payload.isBroken;
  const isPowerUpUsed = payload.isPowerUpUsed;
  const protectedAmount = payload.protectedAmount || 0;
  const powerUpCode = payload.powerUpCode;

  const showTip = !isWinning && !isPowerUpUsed;
  const showPowerUp = !isWinning && isPowerUpUsed;

  let title = isWinning ? "Yeah" : "Ouch";
  title = isBroken ? "Broke" : title;

  const label = isWinning ? "Win" : "Lose";
  const numberColor = isWinning ? "text-green-500" : "text-red-500";

  const gifBaseUrl = process.env.REACT_APP_STATIC_ASSETS  + "/gif/";
  let gifSource = gifBaseUrl + 'confused-face.gif';

  if(isWinning) {
    gifSource = gifBaseUrl + 'money-mouth-face.gif';
  }

  if(isBroken) {
    gifSource = gifBaseUrl + 'face-with-spiral-eyes.gif';
  }

  const gradientBG = isWinning ? "green-background" : "red-background";

  return (

    <div className="h-full w-screen max-w-md px-10 flex flex-col center">

      <div className="grow"></div>

      <div className={`w-full flex flex-col gap-3 items-center justify-center`}>

        <div className="w-full flat-card flex flex-col gap-3 items-center">

          <img src={gifSource} alt="Animated Face" width="75" height="75" />

          <h3 className={`rounded-lg justify-center items-center px-6 py-1.5 bg-green-500 text-white text-2xl ${gradientBG}`}>
            {title}
          </h3>

          <div className="flex gap-2">

            <p className="text-xl font-medium">
              You <span className="uppercase font-bold">{label}</span>
            </p>

            <div className="flex text-xl gap-1 center">

              <CoinIcon h={20} />
              <span className={`${numberColor} leading-tight`}>
                {payload.netResult.toFixed(2)}
              </span>

            </div>

          </div>

          <div className={`flex flex-col gap-1.5 center ${showPowerUp ? '' : 'hidden'}`}>
            <div className="flex gap-1 center">
              <ShieldPowerUpIcon code={powerUpCode} size={20} />
              <p>Shield activated:</p>
            </div>
            <div className="flex center gap-0.5">
              <CoinIcon h={16} />
              <p>
                <span className="text-lg mr-1">{protectedAmount.toFixed(2)}</span>
                saved!
              </p>
            </div>
          </div>

        </div>

        <div className={`${showTip ? '' : 'hidden'}`}>
          <p className="text-base font-medium text-white opacity-90">
            Tip: use a shield to reduce your losses
          </p>
        </div>

      </div>

      <div className="grow"></div>

      <CollectibleXPToast code={payload.collectibleCode} xp={payload.collectibleXPAmount} isXPAdded={payload.isXPAdded} />

      <div className="mb-2">
        <p className="text-base font-medium text-center text-white">Tap to continue</p>
      </div>

    </div>

  );


}

export default RushGameResultNotif;